import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function UseCaseDMOPage() {
  const {
    t
  } = useTranslation();
  return <div className="pt-24" data-id="element-854">
      <section className="relative py-24 lg:py-32 overflow-hidden" data-id="element-855">
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-856">
          <div className="aurora-blob bg-[#FF6B00] w-[600px] h-[600px] top-[-10%] right-[-10%] animate-aurora-1" data-id="element-857"></div>
          <div className="aurora-blob bg-[#FF3CAC] w-[800px] h-[800px] bottom-[-20%] left-[-10%] animate-aurora-2" data-id="element-858"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-859">
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6" data-id="element-860">
            <span className="text-sm font-bold text-gradient uppercase tracking-wider" data-id="element-861">
              {t('useCaseDMO.badge')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-862">
            {t('useCaseDMO.heroTitle')}
            <span className="text-gradient" data-id="element-863">
              {t('useCaseDMO.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-864">
            {t('useCaseDMO.heroDesc')}
          </p>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(255,107,0,0.3)]" data-id="element-865">
            {t('useCaseDMO.bookDemo')}
          </a>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-866">
        <div className="max-w-4xl mx-auto px-6" data-id="element-867">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-868">
            {t('useCaseDMO.challengeTitle')}
          </h2>
          <div className="space-y-6" data-id="element-869">
            {[0, 1, 2].map(idx => <div key={idx} className="flex items-center p-8 bg-[#050505] rounded-2xl border border-white/10" data-id="element-870">
                <div className="w-1.5 h-12 rounded-full bg-white/20 mr-6 shrink-0" data-id="element-871"></div>
                <p className="text-xl text-white/80 font-medium" data-id="element-872">
                  {t(`useCaseDMO.pain${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-873">
        <div className="max-w-7xl mx-auto px-6" data-id="element-874">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-875">
            {t('useCaseDMO.solutionTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-876">
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-877">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-878">
                Trippp Map
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-879">
                {t('useCaseDMO.mapDesc')}
              </p>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 hover:border-white/20 transition-colors" data-id="element-880">
              <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-881">
                Trippp Spark
              </h3>
              <p className="text-white/60 text-lg leading-relaxed" data-id="element-882">
                {t('useCaseDMO.sparkDesc')}
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-883">
            <p className="text-xl text-white/80 max-w-2xl mx-auto italic" data-id="element-884">
              {t('useCaseDMO.sharedNote')}
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-885">
        <div className="max-w-7xl mx-auto px-6" data-id="element-886">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-887">
            {t('useCaseDMO.deploymentsTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-888">
            {[0, 1].map(idx => <div key={idx} className="group relative rounded-3xl overflow-hidden bg-[#050505] min-h-[300px]" data-id="element-889">
                <div className="absolute inset-0 border border-white/10 rounded-3xl group-hover:opacity-0 transition-opacity duration-300" data-id="element-890"></div>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-gradient-animated rounded-3xl" data-id="element-891"></div>
                <div className="relative h-full p-10 flex flex-col justify-end z-10" data-id="element-892">
                  <h3 className="text-3xl font-bold mb-4 text-white" data-id="element-893">
                    {t(`useCaseDMO.deployment${idx}Title`)}
                  </h3>
                  <p className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-894">
                    {t(`useCaseDMO.deployment${idx}Desc`)}
                  </p>
                  <button type="button" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300" data-id="element-895">
                    {t('useCaseDMO.seeItLive')}{' '}
                    <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-896" />
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-897">
        <div className="max-w-4xl mx-auto px-6" data-id="element-898">
          <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-899">
            {t('useCaseDMO.whatYouGetTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-900">
            {[0, 1, 2, 3, 4, 5].map(idx => <div key={idx} className="flex items-center p-6 bg-[#0A0A0A] rounded-2xl border border-white/10" data-id="element-901">
                <div className="w-6 h-6 rounded-full bg-gradient-animated flex items-center justify-center mr-4 shrink-0" data-id="element-902">
                  <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-903">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-904" />
                  </svg>
                </div>
                <p className="text-white/80 font-medium" data-id="element-905">
                  {t(`useCaseDMO.check${idx}`)}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#0A0A0A] border-t border-white/5" data-id="element-906">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-907">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-908"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-909"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-910">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-911">
            {t('useCaseDMO.ctaTitle')}
            <span className="text-gradient" data-id="element-912">
              {t('useCaseDMO.ctaHighlight')}
            </span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-913">
            {t('useCaseDMO.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}